import React, { ReactNode } from "react";
import { STANZE_REALI } from "data/villaGrecoDatiStanze/stanze";
import { useLocation, useNavigate, useSearchParams } from "react-router-dom";
import ListingImageGallery from "components/ListingImageGallery/ListingImageGallery";
import BackgroundSection from "components/BackgroundSection/BackgroundSection";
import SectionSliderNewCategories from "components/SectionSliderNewCategories/SectionSliderNewCategories";
import SectionSubscribe2 from "components/SectionSubscribe2/SectionSubscribe2";
import MobileFooterSticky from "./(components)/MobileFooterSticky";

interface ListingGalleryImage {
  id: number;
  url: string;
}

const DetailPagetLayout = ({ children }: { children: ReactNode }) => {
  const navigate = useNavigate();
  const thisPathname = useLocation().pathname;
  const [searchParams] = useSearchParams();
  const modal = searchParams?.get("modal");
  const stanzaId = searchParams.get("stanzaId");

   // Chiude il modale eliminando i parametri dalla query string
   const handleCloseModalImageGallery = () => {
    let params = new URLSearchParams(document.location.search);
    params.delete("modal");
    params.delete("stanzaId");
    navigate(`${thisPathname}?${params.toString()}`);
  };

  // Recupera le immagini della stanza corrispondente usando l'id
  const getImageGalleryListing = (): ListingGalleryImage[] => {
    if (thisPathname?.includes("/dettagli-appartamento") && stanzaId) {
      const stanza = STANZE_REALI.find((item) => item.id === stanzaId);
      return (
        stanza?.galleryImgs.map((url, index) => ({
          id: index, // ID univoco per ogni immagine
          url: url,  // URL immagine
        })) || [] // Array vuoto se nessuna immagine viene trovata
      );
    }
    return [];
  };
  
  

  return (
    <div className="ListingDetailPage">
      {/* Modale per la galleria immagini */}
      <ListingImageGallery
        isShowModal={modal === "fotoGalleriaStanza"}
        onClose={handleCloseModalImageGallery}
        images={getImageGalleryListing()}
      />

      {/* Contenuto della pagina */}
      <div className="container ListingDetailPage__content">{children}</div>

      {/* Sezioni aggiuntive */}
      <div className="container py-24 lg:py-32">
        <div className="relative py-16">
          <BackgroundSection />
          <SectionSubscribe2 className="pt-24 lg:pt-32" />
        </div>
      </div>

      {/* Footer mobile */}
      <MobileFooterSticky />
    </div>
  );
};

export default DetailPagetLayout;
